var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1232_44595)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "#DEE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.667 18.8333L24.5536 26.4538C25.4351 27.0709 25.8759 27.3795 26.3553 27.499C26.7789 27.6046 27.2218 27.6046 27.6453 27.499C28.1248 27.3795 28.5655 27.0709 29.4471 26.4538L40.3337 18.8333M20.067 36.1666H33.9337C36.1739 36.1666 37.294 36.1666 38.1496 35.7306C38.9023 35.3471 39.5142 34.7352 39.8977 33.9825C40.3337 33.1269 40.3337 32.0068 40.3337 29.7666V21.2333C40.3337 18.993 40.3337 17.8729 39.8977 17.0173C39.5142 16.2646 38.9023 15.6527 38.1496 15.2692C37.294 14.8333 36.1739 14.8333 33.9337 14.8333H20.067C17.8268 14.8333 16.7067 14.8333 15.851 15.2692C15.0984 15.6527 14.4865 16.2646 14.103 17.0173C13.667 17.8729 13.667 18.993 13.667 21.2333V29.7666C13.667 32.0068 13.667 33.1269 14.103 33.9825C14.4865 34.7352 15.0984 35.3471 15.851 35.7306C16.7067 36.1666 17.8268 36.1666 20.067 36.1666Z",
    stroke: "#2948A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1232_44595",
    x: 0.5,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1232_44595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1232_44595",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSquare);
export default __webpack_public_path__ + "static/media/emailSquare.f8a49a9d7532e43f2ae5959a938d5dd8.svg";
export { ForwardRef as ReactComponent };